import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IProduct } from '../../../shared/models/product.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-widget-device-resizer',
    templateUrl: './widget-device-resizer.component.html',
    styleUrls: ['./widget-device-resizer.component.scss'],
    standalone: false
})
export class WidgetDeviceResizerComponent {
  resizing: boolean;
  @Input() widgetCmp: HTMLElement;
  @Input() device: IProduct;
  @Input() widthInSlots: number;
  @Input() minSizeInSlots: number;
  @Input() maxSizeInSlots: number;

  @Output() newSize = new EventEmitter<number>();
  @Output() movingResizerInProcess = new EventEmitter<number>();

  getNewSize(size: number) {
    this.newSize.emit(size);
  }

  resizingInProcess(resizing: boolean) {
    this.resizing = resizing;
  }

  movingResizer(size: number) {
    this.movingResizerInProcess.emit(size);
  }
}
